export * from "./use-instance-locale";
